import Model from 'flarum/common/Model';

export default class ApplicationConfig extends Model {
    name = Model.attribute('name');
    config = Model.attribute('config');
    canEdit = Model.attribute('canEdit');

    protected apiEndpoint(): string {
        return '/applications/configs' + ('id' in this.data ? '/' + this.data.id : '');
    }
}
